import { Component, Vue } from 'vue-property-decorator'
import { BscInscopeProductDTO } from '@core/pages/bsc/api'
import { namespace } from 'vuex-class'

const bscStore = namespace('BscStore')

@Component
export default class BscMixin extends Vue {
  @bscStore.State
  bscInscopeResult: BscInscopeProductDTO[]

  @bscStore.Action
  validateProductIsBscInscope

  get numberOfInscopePolicies () {
    return this.bscInscopeResult.reduce((previous: number, result: BscInscopeProductDTO) => {
      return previous + (result.inscope ? 1 : 0)
    }, 0)
  }
}
